module.exports = __webpack_public_path__ + "img/Factoid-Vertical.svg";